import React, { Fragment } from 'react';

const NativeAppFeatureListYouthSports = () => {
  return (
    <Fragment>
      <li>
        Share your athlete&apos;s matched photo stream with family and friends.
      </li>
      <li>Post &amp; download your favorite action shots in hi-res.</li>
      <li>Create and send Waldograms featuring your photos.</li>
      <li>Order prints delivered directly to your home.</li>
    </Fragment>
  );
};

export default NativeAppFeatureListYouthSports;
